<div class="container">
  <section class="inner-container">
    <section class="secondary-header formHeader">
      <div class="title">
        <button type="button" class="btn btn-primary" (click)="goToServices()"><img src="images/add.png" /> ADD MORE
          SERVICES</button> &nbsp; &emsp;

      </div>
    </section>
    <main>
      <div class="products announcements">
        <div class="content-container">
          <div class="text-center">
            <h1 class="title-default">Hi {{name}},</h1>
            <p class="text-intro">Here are the services you have submitted:</p>
          </div>
          <div class="row text-center">
            <h3>Legend:</h3>
            <div class="legend">
              <h3><strong><img src="images/circular-tick-thick.png" alt="Status"> Completed &nbsp; &nbsp;
                  &nbsp;</strong></h3>
              <h3><strong><img src="images/circular-action-thick.png" alt="Status"> Require Action &nbsp; &nbsp;
                  &nbsp;</strong></h3>
              <h3><strong><img src="images/circular-wait-thick.png" alt="Status"> Pending Our Team To Revert</strong>
              </h3>
            </div>

          </div>
          <div class="inner">
            <div id="services" class="row">

              <div class="col-sm-4 col-md-8 col-md-offset-2" *ngIf="updateBizAcc">
                <div class="box-default height-min-auto bg-red">
                  <div class="row">
                    <div class="col-xs-12 col-xs-offset-0 col-md-5 col-md-offset-0  ">
                      <h3><strong><img class="margin-right-1 .dashboard-icon-svg" src="images/circular-action-thick.png"
                            alt="Status">Update your Business Account Number</strong></h3>
                    </div>
                    <div class="col-md-4 ">
                      <a target="_blank" href="assets/form/sme1st_appform.pdf"
                        class="btn btn-default btn-block btn-checklist pointer bg-white">Download Account Opening
                        Form</a>
                    </div>
                    <!-- <div class="col-md-1 "></div> -->
                    <div class="col-xs-10 col-xs-offset-1 col-md-3 col-md-offset-0  mid">

                      <a (click)="goToUpdateBizAcc()"
                        class="btn btn-default btn-block btn-checklist pointer bg-white">Update Account Number</a>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 col-md-8 col-md-offset-2" *ngFor="let s of submissions; let i = index">
                
                <div class="box-default height-min-auto" *ngIf="s.service">
                  <div class="row bg-yellow-mbb">
                    <div class="col-xs-8 col-xs-offset-2 col-md-6 col-md-offset-0 ">
                      <h3><strong>{{s.service.name}}</strong></h3>
                    </div>
                    <div class="col-md-3 "></div>
                    <div class="col-xs-10 col-xs-offset-1 col-md-3 col-md-offset-0  mid">
                      <a [hidden]="!hasForm(s)" (click)="viewApplication(s)"
                        class="btn btn-default btn-block btn-checklist pointer bg-white">View Application</a>
                    </div>
                  </div>
                  <div class="row bg-status" [hidden]="getSubmissionTagName(s) == null">
                    <div class="col-xs-8 col-xs-offset-2 col-md-4 col-md-offset-0" >
                      <h4>Application Status:
                      </h4>
                      <h4><strong>{{getSubmissionTagName(s)}}</strong></h4>
                    </div>
                    <div class="col-md-6 "></div>
                    <div class="col-xs-10 col-xs-offset-1 col-md-2 col-md-offset-0  mid"
                      [hidden]="getSubmissionTagName(s) == null">
                      <h4>Last updated at:
                      </h4>
                      <h4><strong>{{getSubmissionTagUpdatedAt(s)}}</strong></h4>
                    </div>
                  </div>
                  <div class="row"
                    [hidden]="submissionDetailService.currentTag(s.submission.id,CONSTANT.STATUS.PENDING_ACCOUNT_CREATION) || (this.isMaybank2uPayGroup(s) && !this.hasForm(s)) || (this.isMaybank2uPayGroup(s) && (s.service.id == CONSTANT.SERVICE.MAYBANK2U_BILLER)) || (getSubmissionTagName(s) == null) && (isCc(s) && !isCcEcommerce(s)) || (getSubmissionTagName(s) != null) && (isCc(s) && !(s.service.id == CONSTANT.SERVICE.CARDS_PAYMENT_GATEWAY || (s.service.id == CONSTANT.SERVICE.POS_TERMINAL_MPOS && submissionDetailService.tagExists(s.submission.id,18))))">
                    <div class="col-xs-8 col-xs-offset-2 col-md-4 col-md-offset-0  ">
                    </div>
                    <div class="col-md-6 "></div>
                    <div class="col-xs-10 col-xs-offset-1 col-md-2 col-md-offset-0  mid">
                    </div>
                  </div>
                  <div class="row"
                    *ngIf="(this.isMaybank2uPayGroup(s) && (s.service.id == CONSTANT.SERVICE.MAYBANK2U_BILLER))">
                    <h4 class="mid">Our account manager will contact you for further discussion on this service.</h4>
                  </div>

                  <div class="row"
                    *ngIf="(this.isMaybank2uPayGroup(s) && !this.hasForm(s) && getServiceName(s) !== 'JomPAY')">
                    <h4 class="mid">Our account manager will contact you for further discussion on this service. </h4>
                  </div>

                  <div class="row" *ngIf="(getSubmissionTagName(s) == null) && (isCc(s) && !isCcEcommerce(s))">
                    <h4 class="mid">Our account manager will contact you for further discussion on this service.</h4>
                  </div>

                  <div class="row"
                    *ngIf="(getSubmissionTagName(s) != null) && (isCc(s) && !(s.service.id == CONSTANT.SERVICE.CARDS_PAYMENT_GATEWAY || (s.service.id == CONSTANT.SERVICE.POS_TERMINAL_MPOS && submissionDetailService.tagExists(s.submission.id,18))))">
                    <h4 class="mid">We will notified you via email once your application is approved.</h4>
                  </div>


                  <!-- ACCOUNT NUMBER -->
                  <!-- <div *ngIf="submissionDetailService.subtagExists(s.submission.id,1) &&  isCcEcommerce(s)">
                            <div class="row .margin-bottom-1em">
                              <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 " >
                                <h4 *ngIf="!submissionDetailService.subtagExists(s.submission.id,1)"><img class="margin-right-1 .dashboard-icon-svg" src="images/circular-action-thick.png" alt="Status">Pending business account creation</h4>

                                <h4 *ngIf="submissionDetailService.subtagExists(s.submission.id,1)"><img class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png" alt="Status">Completed business account creation</h4>

                              </div>

                              <div *ngIf="!submissionDetailService.subtagExists(s.submission.id,1)" class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                                <a (click)="viewWebsiteChecklist(s)" class="btn btn-default btn-block btn-checklist pointer">Update Business Account</a>
                              </div>
                            </div>
                          </div> -->


                  <!-- WEBCHECKLIST COMPONENT -->
                  <div *ngIf="isCcEcommerce(s)">
                    <div class="row .margin-bottom-1em">
                      <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 ">
                        <h4
                          *ngIf="!submissionDetailService.subtagExists(s.submission.id,3) && submissionDetailService.currentTag(s.submission.id,CONSTANT.STATUS.CARDS.PENDING_WEB_CHECKLIST_APPROVAL) && !isWebsiteChecklistSubmitted(payee)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-action-thick.png"
                            alt="Status">You need to review your website requirement
                        </h4>

                        <h4
                          *ngIf="!submissionDetailService.subtagExists(s.submission.id,3) && submissionDetailService.currentTag(s.submission.id,CONSTANT.STATUS.CARDS.PENDING_WEB_CHECKLIST_APPROVAL) && isWebsiteChecklistSubmitted(payee)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-wait-thick.png"
                            alt="Status">Our team is reviewing your website requirement
                        </h4>

                        <h4 *ngIf="submissionDetailService.subtagExists(s.submission.id,3)"><img
                            class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png"
                            alt="Status">Nice! Your website is up to our requirement</h4>

                        <!-- <h4 ><i class="margin-right-1 icon icon-checkmark success-green"></i>{{getSubmissionSubTagName(s)}}</h4> -->
                      </div>

                      <div
                        *ngIf="!submissionDetailService.subtagExists(s.submission.id,3) && !isWebsiteChecklistSubmitted(payee)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewWebsiteChecklist(s)"
                          class="btn btn-default btn-block btn-checklist pointer">Review now</a>
                      </div>

                      <div
                        *ngIf="!submissionDetailService.subtagExists(s.submission.id,3) && submissionDetailService.currentTag(s.submission.id,CONSTANT.STATUS.CARDS.PENDING_WEB_CHECKLIST_APPROVAL)  && isWebsiteChecklistSubmitted(payee)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <button (click)="viewWebsiteChecklist(s)"
                          class="btn btn-default btn-block btn-checklist pointer">View Requirement</button>
                        <!-- <div class="custom-radio">
                                  <label for="running_n">
                                    <input type="radio" id="running_n" [disabled]="getSubmissionSubTagDeletedAt(s) != null" title="View Application" (click)="viewWebsiteChecklist(s)" />
                                    <span>
                                      Pending Admin Approval
                                    </span>
                                  </label>
                                </div> -->
                      </div>

                      <div *ngIf="submissionDetailService.subtagExists(s.submission.id,3)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewWebsiteChecklist(s)"
                          class="btn btn-default btn-block btn-checklist pointer">View Requirement</a>
                        <!-- <div class="custom-radio">
                                  <label for="running_n">
                                    <input type="radio" id="running_n" [disabled]="getSubmissionSubTagDeletedAt(s) != null" title="View Application" (click)="viewWebsiteChecklist(s)" />
                                    <span>
                                      Pending Admin Approval
                                    </span>
                                  </label>
                                </div> -->
                      </div>


                    </div>
                  </div>

                  <!-- Ecom Cards LETTER OFFER-->
                  <div
                    *ngIf="submissionDetailService.tagExists(s.submission.id,18) &&  (s.service.id == CONSTANT.SERVICE.CARDS_PAYMENT_GATEWAY ) ">
                    <div class="row .margin-bottom-1em">
                      <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 ">

                        <h4
                          *ngIf="!submissionDetailService.subtagExists(s.submission.id,4) && !submissionDetailService.subtagExists(s.submission.id,5)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-action-thick.png"
                            alt="Status">Your application is approved. Please check your email for on how to accept the
                          offer.
                        </h4>

                        <h4 *ngIf="submissionDetailService.subtagExists(s.submission.id,4)"><img
                            class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png"
                            alt="Status">Offer accepted</h4>

                        <h4 *ngIf="submissionDetailService.subtagExists(s.submission.id,5)"><img
                            class="margin-right-1 .dashboard-icon-svg" src="images/circular-wait-thick.png"
                            alt="Status">Offer rejected. Pending re-evaluation by admin.</h4>

                        <!-- <h4 ><i class="margin-right-1 icon icon-checkmark success-green"></i>{{getSubmissionSubTagName(s)}}</h4> -->
                      </div>


                      <div
                        *ngIf="!submissionDetailService.subtagExists(s.submission.id,4) && !submissionDetailService.subtagExists(s.submission.id,5)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewEcomCardsOfferLetter(s)"
                          class="btn btn-default btn-block btn-checklist pointer">Review Letter of Offer</a>
                      </div>

                      <div *ngIf="submissionDetailService.subtagExists(s.submission.id,4)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewEcomCardsOfferLetter(s)"
                          class="btn btn-default btn-block btn-checklist pointer">View Letter of Offer</a>
                      </div>






                    </div>
                  </div>

                  <!-- POS LETTER OFFER-->
                  <div
                    *ngIf="submissionDetailService.tagExists(s.submission.id,18) &&  (s.service.id == CONSTANT.SERVICE.POS_TERMINAL_MPOS) ">
                    <div class="row .margin-bottom-1em">
                      <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 ">

                        <h4
                          *ngIf="!submissionDetailService.subtagExists(s.submission.id,4) && !submissionDetailService.subtagExists(s.submission.id,5)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-action-thick.png"
                            alt="Status">Your application is approved. Please check your email for on how to accept the
                          offer.
                        </h4>

                        <h4 *ngIf="submissionDetailService.subtagExists(s.submission.id,4)"><img
                            class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png"
                            alt="Status">Offer accepted</h4>

                        <h4 *ngIf="submissionDetailService.subtagExists(s.submission.id,5)"><img
                            class="margin-right-1 .dashboard-icon-svg" src="images/circular-wait-thick.png"
                            alt="Status">Offer rejected. Pending re-evaluation by admin.</h4>

                        <!-- <h4 ><i class="margin-right-1 icon icon-checkmark success-green"></i>{{getSubmissionSubTagName(s)}}</h4> -->
                      </div>


                      <div
                        *ngIf="!submissionDetailService.subtagExists(s.submission.id,4) && !submissionDetailService.subtagExists(s.submission.id,5)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewPOSOfferLetter(s)"
                          class="btn btn-default btn-block btn-checklist pointer">Review Offer Letter</a>
                      </div>

                      <div *ngIf="submissionDetailService.subtagExists(s.submission.id,4)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewPOSOfferLetter(s)" class="btn btn-default btn-block btn-checklist pointer">View
                          offer letter</a>
                      </div>






                    </div>
                  </div>

                  <!-- USER ACCEPTANCE TEST (UAT) -->
                  <div
                    *ngIf="submissionDetailService.tagExists(s.submission.id,21) 
                          && !submissionDetailService.currentTag(s.submission.id,CONSTANT.STATUS.CARDS.GO_LIVE) &&  isCcEcommerce(s)">
                    <div class="row .margin-bottom-1em">
                      <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 ">
                        <h4 *ngIf="submissionDetailService.currentTag(s.submission.id,21)"><img
                            class="margin-right-1 .dashboard-icon-svg" src="images/circular-action-thick.png"
                            alt="Status">Good news, your UAT data is ready for you to test.Check your email for more
                          details</h4>

                        <h4 *ngIf="submissionDetailService.currentTag(s.submission.id,22)"><img
                            class="margin-right-1 .dashboard-icon-svg" src="images/circular-wait-thick.png"
                            alt="Status">We received your UAT completion sign off. We will verify your test data soon!
                        </h4>

                        <h4
                          *ngIf="submissionDetailService.currentTag(s.submission.id,CONSTANT.STATUS.CARDS.UAT_VERIFIED)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png"
                            alt="Status">We are preparing you to Go Live. We will update you via email soon!
                        </h4>

                      </div>


                      <div class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewUatLiveDataCardsEcom(s)"
                          class="btn btn-default btn-block btn-checklist pointer">View UAT data</a>
                      </div>

                    </div>
                  </div>

                  <!-- PROD DATA() -->
                  <div
                    *ngIf="submissionDetailService.currentTag(s.submission.id,CONSTANT.STATUS.CARDS.GO_LIVE) &&  isCcEcommerce(s)">
                    <div class="row .margin-bottom-1em">
                      <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 ">

                        <h4 *ngIf="submissionDetailService.currentTag(s.submission.id,CONSTANT.STATUS.CARDS.GO_LIVE)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png"
                            alt="Status">Your PROD data is ready for you to implement. Check your email for more
                          details.
                        </h4>

                      </div>


                      <div class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewUatLiveDataCardsEcom(s)"
                          class="btn btn-default btn-block btn-checklist pointer">View Prod data</a>
                      </div>

                    </div>
                  </div>

                  <!-- payment notification technical requirement for online banking -->
                  <div *ngIf="isMaybank2uPay(s)">
                    <div class="row .margin-bottom-1em">
                      <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 ">
                        <h4 *ngIf="!submissionDetailService.subtagExists(s.submission.id,8)"><img
                            class="margin-right-1 .dashboard-icon-svg" src="images/circular-action-thick.png"
                            alt="Status">You need to fill up payment notification technical requirement</h4>

                        <h4 *ngIf="submissionDetailService.subtagExists(s.submission.id,8)"><img
                            class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png"
                            alt="Status">Payment notification technical requirement updated</h4>

                        <!-- <h4 *ngIf="submissionDetailService.tagExists(s.submission.id,7)"><img class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png" alt="Status">You may go-live with your production / live payee code.</h4> -->

                      </div>

                      <div *ngIf="!submissionDetailService.subtagExists(s.submission.id,8)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewTechnicalRequirementOnlineBanking(s)"
                          class="btn btn-default btn-block btn-checklist pointer">Fill in now</a>
                      </div>

                      <div *ngIf="submissionDetailService.subtagExists(s.submission.id,8)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewTechnicalRequirementOnlineBanking(s)"
                          class="btn btn-default btn-block btn-checklist pointer">View info</a>
                      </div>



                      <!-- <div *ngIf="submissionDetailService.tagExists(s.submission.id,7)" class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                                <a (click)="viewUatLiveDataOnlineBanking(s)" class="btn btn-default btn-block btn-checklist pointer">View Live data</a>
                              </div> -->
                    </div>
                  </div>

                  <!-- Letter offer for online banking -->
                  <div *ngIf="isMaybank2uPay(s)">
                    <div class="row .margin-bottom-1em">
                      <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 ">
                        <h4
                          *ngIf="submissionDetailService.tagExists(s.submission.id,CONSTANT.STATUS.ONLINE_BANKING.APPROVED)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png"
                            alt="Status">Congratulations! Your application is approved and offer letter is ready.
                        </h4>

                        <!-- <h4 *ngIf="submissionDetailService.tagExists(s.submission.id,7)"><img class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png" alt="Status">You may go-live with your production / live payee code.</h4> -->

                      </div>

                      <div
                        *ngIf="submissionDetailService.tagExists(s.submission.id,CONSTANT.STATUS.ONLINE_BANKING.APPROVED)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewOnlineBankingOfferLetter(s)"
                          class="btn btn-default btn-block btn-checklist pointer">View Letter of Offer</a>
                      </div>




                      <!-- <div *ngIf="submissionDetailService.tagExists(s.submission.id,7)" class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                                <a (click)="viewUatLiveDataOnlineBanking(s)" class="btn btn-default btn-block btn-checklist pointer">View Live data</a>
                              </div> -->
                    </div>
                  </div>




                  <!-- UAT / Go live for online banking -->
                  <div *ngIf="(submissionDetailService.tagExists(s.submission.id,14)) && isMaybank2uPay(s)">
                    <div class="row .margin-bottom-1em">
                      <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 ">
                        <h4
                          *ngIf="submissionDetailService.tagExists(s.submission.id,14) && !submissionDetailService.subtagExists(s.submission.id,10)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-action-thick.png"
                            alt="Status">Good news, your User Acceptance Test (UAT) data is ready for you to test
                        </h4>

                        <h4
                          *ngIf="submissionDetailService.tagExists(s.submission.id,14) && submissionDetailService.subtagExists(s.submission.id,10) && !submissionDetailService.tagExists(s.submission.id,CONSTANT.STATUS.ONLINE_BANKING.APPLICATION_PROCESS_COMPLETED)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png"
                            alt="Status">You have confirmed that UAT has been completed
                        </h4>

                        <h4
                          *ngIf="submissionDetailService.tagExists(s.submission.id,CONSTANT.STATUS.ONLINE_BANKING.APPLICATION_PROCESS_COMPLETED)">
                          <img class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png"
                            alt="Status">Your LIVE PAYEE CODE is ready for you to implement. Please check your email for
                          guideline.
                        </h4>

                        <!-- <h4 *ngIf="submissionDetailService.tagExists(s.submission.id,7)"><img class="margin-right-1 .dashboard-icon-svg" src="images/circular-tick-thick.png" alt="Status">You may go-live with your production / live payee code.</h4> -->

                      </div>

                      <div
                        *ngIf="submissionDetailService.tagExists(s.submission.id,14) && !submissionDetailService.subtagExists(s.submission.id,10)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewUatLiveDataOnlineBanking(s)"
                          class="btn btn-default btn-block btn-checklist pointer">Get Test Payee Code</a>
                      </div>

                      <div
                        *ngIf="submissionDetailService.tagExists(s.submission.id,14) && submissionDetailService.subtagExists(s.submission.id,10) && !submissionDetailService.tagExists(s.submission.id,CONSTANT.STATUS.ONLINE_BANKING.APPLICATION_PROCESS_COMPLETED)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewUatLiveDataOnlineBanking(s)"
                          class="btn btn-default btn-block btn-checklist pointer">View UAT data</a>
                      </div>

                      <div
                        *ngIf="submissionDetailService.tagExists(s.submission.id,CONSTANT.STATUS.ONLINE_BANKING.APPLICATION_PROCESS_COMPLETED)"
                        class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                        <a (click)="viewUatLiveDataOnlineBanking(s)"
                          class="btn btn-default btn-block btn-checklist pointer">View Live data</a>
                      </div>

                      <!-- <div *ngIf="submissionDetailService.tagExists(s.submission.id,7)" class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                                <a (click)="viewUatLiveDataOnlineBanking(s)" class="btn btn-default btn-block btn-checklist pointer">View Live data</a>
                              </div> -->
                    </div>
                  </div>


                  <div class="row" *ngIf="getServiceName(s) === 'JomPAY'">
                    <div>
                      <div class="col-sm-12">
                        <h4 class="mid" style="margin-top:15px;"
                          *ngIf="['Approved and Document Generated'].includes(getSubmissionTagName(s))">
                          <img alt="Status" src="images/circular-action-thick.png">
                          Documents Generated proceed to download and upload.
                          <button class="btn btn-default btn-checklist pointer" (click)="toggleJompayInfo()">View
                            Info</button>
                        </h4>
                        <h4 class="mid" style="margin-top:15px;"
                          *ngIf="['Document Rejected'].includes(getSubmissionTagName(s))">
                          <img alt="Status" src="images/circular-action-thick.png">
                          Documents Rejected due to Invalid Data.
                          <button class="btn btn-default btn-checklist pointer" (click)="toggleJompayInfo()">View
                            Info</button>
                        </h4>
                        <h4 class="mid" style="margin-top:15px;"
                          *ngIf="['Generated documents Received'].includes(getSubmissionTagName(s))">
                          <img alt="Status" src="images/circular-wait-thick.png">
                          Pending Our Team To Revert.
                        </h4>
                        <h4 class="mid" style="margin-top:15px;"
                          *ngIf="['Completed'].includes(getSubmissionTagName(s))">
                          <img alt="Status" src="images/circular-tick-thick.png">
                          Completed
                        </h4>
                      </div>

                      <!-- <div class="col-md-12" *ngIf="['Approved', 'Approved and Document Generated
                              '].includes(getSubmissionTagName(s))">
                                <jompay-offer-letter [submission]="s" *ngIf="isShowJompayInfo"></jompay-offer-letter>
                              </div>
                              <div class="col-md-12" *ngIf="['Approved', 'Approved and Document Generated
                              ', 'Rejected', 'Document Rejected'].includes(getSubmissionTagName(s))">
                                <app-jompay-documents-upload [submission]="s" *ngIf="isShowJompayInfo"></app-jompay-documents-upload>
                              </div> -->


                      <div class="col-md-12"
                        *ngIf="['Approved and Document Generated'].includes(getSubmissionTagName(s))">
                        <jompay-offer-letter [submission]="s" *ngIf="isShowJompayInfo"></jompay-offer-letter>
                      </div>
                      <div class="col-md-12"
                        *ngIf="['Approved and Document Generated', 'Document Rejected'].includes(getSubmissionTagName(s))">
                       <app-jompay-documents-upload [submission]="s" *ngIf="isShowJompayInfo">
                        </app-jompay-documents-upload>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="info" [hidden]="getMessage(s) == null">
                            <p class="mid"> Our account manager will contact you for further discussion on this service.</p>
                          </div> -->
                  <!-- <div class="row margin-top-3em">
                            <div class="col-xs-10 col-xs-offset-1 col-md-5 col-md-offset-0 ">
                              <div class="" [hidden]="!hasForm(s)">
                                <a title="View Application" (click)="viewApplication(s)" class="btn btn-default btn-block pointer line-height-2em">View Application</a>
                              </div>
                            </div>

                          </div> -->
                </div>
              </div>
              <!-- <div class="col-sm-4 col-md-2 col-md-offset-5">
                        <button (click)="goToServices()" class="box-default height-auto btn-block btn"> Add More Services</button>
                  </div> -->

            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</div>